import LegalPageLayout from '../components/LegalPageLayout';
import { LEGAL } from '../lib/legalConstants';

export default function PrivacyPolicy() {
  return (
    <LegalPageLayout
      title="Politique de confidentialité"
      subtitle={`${LEGAL.appName} — ${LEGAL.appUrl}`}
    >
      <p className="legal-meta">Dernière mise à jour : {LEGAL.lastUpdated}</p>

      <h2>1. Responsable du traitement</h2>
      <p>
        La société {LEGAL.companyLegalName}, {LEGAL.companyForm}, immatriculée au RCS de{' '}
        {LEGAL.rcs} (SIRET {LEGAL.siret}), dont le siège social est situé{' '}
        {LEGAL.registeredOffice}, édite le service en ligne {LEGAL.appName} ({LEGAL.appUrl}),
        application web de jeu de Tarot associée à la marque {LEGAL.brand}.
      </p>
      <p>
        Représentant légal : {LEGAL.manager}, gérant.{' '}
        {LEGAL.hasDpo
          ? 'Délégué à la protection des données (DPO) : voir contact ci-dessous.'
          : "Aucun délégué à la protection des données (DPO) n'est désigné ; les demandes relatives aux données personnelles sont traitées par le responsable du traitement."}
      </p>
      <p>
        Adresse de contact pour les données personnelles :{' '}
        <a href={`mailto:${LEGAL.contactEmail}`}>{LEGAL.contactEmail}</a> (même adresse
        que le siège social).
      </p>

      <h2>2. Hébergeur</h2>
      <p>
        Les données traitées dans le cadre de {LEGAL.appName} sont hébergées par{' '}
        {LEGAL.hoster.name}, {LEGAL.hoster.address}.
      </p>

      <h2>3. Données collectées</h2>
      <p>Selon les fonctionnalités que vous utilisez, nous pouvons traiter :</p>
      <ul>
        <li>
          <strong>Identifiants de compte</strong> : pseudo, mot de passe (stocké sous forme
          de condensat cryptographique), adresse e-mail, prénom et nom le cas échéant.
        </li>
        <li>
          <strong>Connexion via un tiers (Google, Facebook…)</strong> : identifiant du
          fournisseur, adresse e-mail, nom et prénom ou nom d&apos;affichage, photo de profil
          le cas échéant, uniquement avec votre consentement lors de l&apos;autorisation OAuth.
        </li>
        <li>
          <strong>Profil joueur</strong> : avatar, ville, pays, profession, commentaire,
          préférences de confidentialité des contacts, statut de licence et d&apos;abonnement.
        </li>
        <li>
          <strong>Données de jeu</strong> : parties jouées, scores, classements, fréquentation
          des espaces Détente et Compétition, messages de chat et conversations associées
          à votre pseudo.
        </li>
        <li>
          <strong>Données techniques</strong> : adresse IP, horodatages de connexion,
          identifiants de session, journaux techniques nécessaires à la sécurité et au
          bon fonctionnement du service.
        </li>
      </ul>

      <h2>4. Finalités et bases légales</h2>
      <ul>
        <li>
          <strong>Création et gestion de votre compte</strong> (exécution du contrat /
          mesures précontractuelles).
        </li>
        <li>
          <strong>Authentification</strong>, y compris via OAuth, et accès aux parties en
          ligne (exécution du contrat).
        </li>
        <li>
          <strong>Fourniture du jeu en ligne</strong>, du chat, des classements et des
          fonctionnalités associées (exécution du contrat).
        </li>
        <li>
          <strong>Sécurité, prévention des abus et modération</strong> (intérêt légitime).
        </li>
        <li>
          <strong>Support utilisateur</strong> et réponses à vos demandes (exécution du
          contrat / intérêt légitime).
        </li>
        <li>
          <strong>Respect des obligations légales</strong>, le cas échéant (facturation,
          conservation de preuves).
        </li>
      </ul>

      <h2>5. Connexion Google, Facebook et autres fournisseurs OAuth</h2>
      <p>
        Si vous choisissez « Continuer avec Google » ou « Continuer avec Facebook » (ou un
        autre fournisseur proposé), nous recevons les informations autorisées par ce
        fournisseur lors de votre consentement. Nous utilisons votre adresse e-mail pour
        créer ou rattacher un compte {LEGAL.brand}, vérifier votre identité et, le cas
        échéant, vous permettre de choisir ou créer un pseudo. Nous ne publions pas votre
        adresse e-mail aux autres joueurs sans votre action explicite.
      </p>
      <p>
        Vous pouvez révoquer l&apos;accès accordé à {LEGAL.appName} depuis les paramètres
        de sécurité de votre compte Google ou Facebook (ou du fournisseur concerné). Voir
        aussi la section{' '}
        <a href="#suppression-donnees">Suppression de vos données</a> ci-dessous.
      </p>

      <h2 id="suppression-donnees">6. Suppression de vos données (dont connexion Facebook)</h2>
      <p>
        Nous distinguons la <strong>suppression de la liaison OAuth</strong> (données
        « Platform Data » transmises par Facebook ou Google lors de la connexion) et la{' '}
        <strong>suppression complète de votre compte joueur</strong> Webtarot.
      </p>

      <h3>6.1. Suppression automatique de la liaison Facebook</h3>
      <p>
        Si vous retirez l&apos;application {LEGAL.appName} de votre compte Facebook
        (Paramètres Facebook → Applications et sites web → Webtarot Neo → Supprimer),
        Facebook nous adresse une demande de suppression. Nous supprimons alors
        automatiquement, dans notre base, la ligne de liaison OAuth associée à votre
        identifiant Facebook (identifiant Facebook, e-mail OAuth, nom affiché, tokens).
      </p>
      <p>
        Facebook vous redirige vers une page de suivi avec un code de confirmation :{' '}
        <a href={LEGAL.dataDeletionStatusUrl}>{LEGAL.dataDeletionStatusUrl}</a>.
        Cette suppression <strong>ne supprime pas</strong> votre pseudo Webtarot, vos
        parties, scores ni messages de chat si un compte joueur avait déjà été créé.
      </p>

      <h3>6.2. Suppression de la liaison Google ou autre fournisseur</h3>
      <p>
        Révoquez l&apos;accès depuis les paramètres de sécurité du fournisseur concerné,
        puis écrivez à{' '}
        <a href={`mailto:${LEGAL.contactEmail}`}>{LEGAL.contactEmail}</a> si vous souhaitez
        que nous effacions aussi la liaison enregistrée côté Webtarot (traitement sous 30
        jours ouvrés).
      </p>

      <h3>6.3. Suppression complète du compte joueur</h3>
      <p>
        Pour effacer l&apos;ensemble des données liées à votre pseudo (profil, historique
        de jeu, messages, etc.), adressez une demande explicite à{' '}
        <a href={`mailto:${LEGAL.contactEmail}`}>{LEGAL.contactEmail}</a> en indiquant votre
        pseudo et, si possible, l&apos;adresse e-mail du compte. Nous traitons les demandes
        dans un délai raisonnable, sous réserve des obligations légales de conservation
        (par ex. preuves comptables) et de l&apos;intérêt des autres joueurs pour
        l&apos;historique des parties déjà jouées.
      </p>

      <h2>7. Destinataires et sous-traitants</h2>
      <p>Vos données peuvent être accessibles, dans la stricte limite de leurs missions :</p>
      <ul>
        <li>aux équipes techniques et d&apos;assistance de {LEGAL.companyName} ;</li>
        <li>
          à {LEGAL.hoster.name} ({LEGAL.hoster.address}), hébergeur des serveurs et bases
          de données ;
        </li>
        <li>
          aux fournisseurs d&apos;authentification que vous choisissez (Google, Facebook…) ;
        </li>
        <li>
          aux autres joueurs, uniquement pour les informations que vous rendez publiques
          (pseudo, avatar, éléments de profil, messages de chat).
        </li>
      </ul>
      <p>
        Nous ne vendons pas vos données personnelles. Toute transmission hors Union
        européenne, si elle devait avoir lieu, serait encadrée par les garanties prévues
        par la réglementation applicable.
      </p>

      <h2>8. Durées de conservation</h2>
      <ul>
        <li>
          <strong>Compte actif</strong> : conservation tant que le compte est utilisé et,
          en cas d&apos;inactivité prolongée, selon les règles de suppression automatique
          des pseudos inactifs communiquées sur{' '}
          <a href={LEGAL.mainSiteUrl} target="_blank" rel="noopener noreferrer">
            {LEGAL.mainSiteUrl}
          </a>.
        </li>
        <li>
          <strong>Données de jeu et statistiques</strong> : conservées pour l&apos;historique
          des parties et classements, sauf demande de suppression compatible avec nos
          obligations.
        </li>
        <li>
          <strong>Journaux techniques</strong> : durée limitée, proportionnée aux besoins
          de sécurité et de diagnostic (généralement de quelques semaines à quelques mois).
        </li>
      </ul>

      <h2>9. Vos droits</h2>
      <p>
        Conformément au Règlement général sur la protection des données (RGPD) et à la
        loi « Informatique et Libertés », vous disposez des droits d&apos;accès, de
        rectification, d&apos;effacement, de limitation, d&apos;opposition et de portabilité
        lorsque applicable.
      </p>
      <p>
        Pour exercer vos droits, écrivez à{' '}
        <a href={`mailto:${LEGAL.contactEmail}`}>{LEGAL.contactEmail}</a> en précisant
        votre pseudo et, si possible, l&apos;adresse e-mail associée à votre compte.
        Vous pouvez également introduire une réclamation auprès de la CNIL (
        <a href="https://www.cnil.fr" target="_blank" rel="noopener noreferrer">
          www.cnil.fr
        </a>
        ).
      </p>

      <h2>10. Cookies et stockage local</h2>
      <p>
        {LEGAL.appName} utilise le stockage local de votre navigateur (par ex. session
        de connexion) et des cookies strictement nécessaires au fonctionnement et à la
        sécurité du service. Aucun cookie publicitaire tiers n&apos;est déposé dans le
        cadre de l&apos;authentification OAuth.
      </p>

      <h2>11. Sécurité</h2>
      <p>
        Nous mettons en œuvre des mesures techniques et organisationnelles adaptées
        (authentification, chiffrement des communications HTTPS, mots de passe condensés,
        contrôle d&apos;accès) pour protéger vos données contre l&apos;accès non autorisé,
        la perte ou l&apos;altération.
      </p>

      <h3 id="empreinte-appareil">11.1. Empreinte d&apos;appareil (lutte contre la triche en compétition)</h3>
      <p>
        Pour garantir l&apos;équité des classements en{' '}
        <strong>tournois différés</strong> et plus généralement dans l&apos;Espace
        Compétition, {LEGAL.appName} collecte au moment où vous démarrez une donne de
        compétition une <strong>empreinte technique de votre appareil</strong>,
        composée des éléments suivants :
      </p>
      <ul>
        <li>
          un <strong>identifiant de navigateur</strong> (visitor ID) généré localement
          par la bibliothèque open-source FingerprintJS (MIT) à partir de caractéristiques
          publiques de votre navigateur (police, fuseau horaire, plug-ins exposés, etc.) ;
        </li>
        <li>
          en application native iOS / Android, l&apos;<strong>identifiant
          d&apos;installation</strong> fourni par le système d&apos;exploitation
          (Capacitor <code>Device.getId()</code>), qui change à chaque
          réinstallation de l&apos;application ;
        </li>
        <li>
          votre <strong>adresse IP</strong> et le numéro d&apos;autonomous system (ASN)
          de votre opérateur, collectés côté serveur lors de la requête ;
        </li>
        <li>
          le <strong>user-agent</strong> du navigateur ou de l&apos;application native.
        </li>
      </ul>
      <p>
        <strong>Finalité unique</strong> : empêcher qu&apos;une même personne joue
        une donne de compétition différée sous plusieurs pseudos depuis le même
        appareil afin d&apos;en tirer un avantage indu (la donne étant connue à la
        seconde tentative).
      </p>
      <p>
        <strong>Base légale</strong> : intérêt légitime de {LEGAL.companyName} et de
        l&apos;ensemble des joueurs à la sincérité des classements en compétition.
      </p>
      <p>
        <strong>Durée de conservation</strong> : 13 mois maximum. Les enregistrements
        plus anciens sont automatiquement purgés.
      </p>
      <p>
        <strong>Ce que nous ne faisons pas</strong> avec ces données : aucune
        utilisation à des fins analytiques, marketing, publicitaires ou de profilage
        comportemental. L&apos;empreinte n&apos;est jamais transmise à des tiers et
        n&apos;est consultable que par les administrateurs habilités, exclusivement
        pour la modération anti-triche.
      </p>
      <p>
        Si vous pensez qu&apos;un conflit a été déclenché à tort (partage légitime
        d&apos;un appareil au sein d&apos;un couple, d&apos;une famille ou d&apos;un
        club), contactez{' '}
        <a href={`mailto:${LEGAL.contactEmail}`}>{LEGAL.contactEmail}</a>. Une mise
        en liste blanche est possible et n&apos;affecte pas vos parties futures.
      </p>

      <h3>11.2. Paiement par carte bancaire (Stripe)</h3>
      <p>
        Lorsque vous souscrivez à un abonnement payant, le règlement est traité par
        notre prestataire de paiement <strong>Stripe Payments Europe, Ltd.</strong>
        (1 Grand Canal Street Lower, Dublin 2, Irlande), conformément à leur{' '}
        <a href="https://stripe.com/fr/privacy" target="_blank" rel="noopener noreferrer">
          politique de confidentialité
        </a>.
      </p>
      <p>
        {LEGAL.appName} ne stocke <strong>jamais</strong> votre numéro de carte
        bancaire. Nous conservons uniquement :
      </p>
      <ul>
        <li>un identifiant client Stripe (utilisé pour rattacher votre pseudo) ;</li>
        <li>l&apos;identifiant de votre abonnement et son statut (actif, annulé, etc.) ;</li>
        <li>les dates de début et de fin de période d&apos;abonnement.</li>
      </ul>
      <p>
        Pour gérer votre carte bancaire ou résilier votre abonnement, utilisez le
        bouton « Gérer ma carte bancaire » de la page « Mon abonnement », qui vous
        redirige vers le portail sécurisé Stripe.
      </p>

      <h2>12. Modifications</h2>
      <p>
        Cette politique peut être mise à jour pour refléter l&apos;évolution du service
        ou de la réglementation. La date de dernière mise à jour figure en tête de page.
        L&apos;utilisation continue de {LEGAL.appName} après publication vaut prise de
        connaissance de la version en vigueur.
      </p>

      <h2>13. Documents connexes</h2>
      <p>
        Les{' '}
        <a href="/cgu">conditions d&apos;utilisation</a> de {LEGAL.appName} complètent
        cette politique. Les conditions générales de vente de licences et d&apos;abonnements
        restent disponibles sur{' '}
        <a href="https://boutique.webtarot.fr/cgv.php" target="_blank" rel="noopener noreferrer">
          boutique.webtarot.fr
        </a>.
      </p>
    </LegalPageLayout>
  );
}
